<script setup lang="ts">
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { type PropType, reactive, watch } from 'vue'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
})

const emits = defineEmits(['update'])
const { trs } = useTranslate()

const currentValues = reactive({
  file_type: props.field?.file_type || 'DOCUMENT',
})

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})

const items = [
  { value: 'IMAGE', title: trs('itf.file_types.IMAGE') },
  { value: 'DOCUMENT', title: trs('itf.file_types.DOCUMENT') },
  { value: 'OTHER', title: trs('itf.file_types.OTHER') },
]
</script>

<template>
  <VSelect :label="$t('itf.file_type')" v-model="currentValues.file_type" :items />
</template>
